import React from 'react';

const Root = () => {
    return (
        <div>
            Root
        </div>
    );
};

export default Root;